var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkorders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58564 0L11.5781 2.39642V7.1265L15.1713 9.28682V14.6048L11.1784 17L7.58584 14.8441L3.99204 17L0 14.6047V9.279L3.5932 7.1265V2.39416L7.58564 0ZM0.99811 11.0453V14.0396L3.39337 15.4769V12.4826L0.99811 11.0453ZM6.98677 11.0453L4.59111 12.4826V15.4769L6.98677 14.0396V11.0453ZM8.1845 11.0453V14.0396L10.5798 15.4769V12.4826L8.1845 11.0453ZM14.1732 11.0453L11.7775 12.4826V15.4769L14.1732 14.0396V11.0453ZM3.99244 8.05095L0.99811 9.84754L3.99244 11.6441L7.04301 9.84754L3.99244 8.05095ZM11.1788 8.05095L8.12826 9.84754L11.1788 11.6441L14.1732 9.84754L11.1788 8.05095ZM4.59131 4.15832V7.15265L6.98657 8.58992V5.59559L4.59131 4.15832ZM10.58 4.15832L8.1843 5.59559V8.58992L10.58 7.15265V4.15832ZM7.58564 1.16399L4.59131 2.96058L7.58564 4.75718L10.58 2.96058L7.58564 1.16399Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkorders);
export default __webpack_public_path__ + "static/media/bulk orders.036055b8219da1fea208c313b6784292.svg";
export { ForwardRef as ReactComponent };